import { IExam } from "../../../types"
import axios from '../../../helpers/axios'
import loadData from '../../../helpers/data-loader'

export default {
  async finish (context: IExam) {
    const response = await axios().post(context.endpoints.results)
    return response.data;
  },

  async loadDataAsyn() {
    return Promise.resolve(this.loadData())
  },

  loadData() {
    return loadData("exam_data")
  },
}
